import { useEffect, useState } from 'react';
import { NextActionBarBtn, Timer } from '../../Player/styles';
import { Flex } from '../../../styles';
import { __t } from '../../../i18n';

const AdCounter = ({ player, hasVast }: { player: HTMLVideoElement; hasVast: (val: boolean) => void }) => {
  const [counter, setCounter] = useState<number | undefined>();

  useEffect(() => {
    const onShowAdCounter = (e: CustomEvent) => {
      hasVast(true);
      setCounter(Math.round(e.detail.counter));
    };
    const onComplete = () => {
      hasVast(false);
      setCounter(undefined);
    };
    const onSeeking = () => {
      setCounter(undefined);
      hasVast(false);
    };

    player.addEventListener('vast.showAdCounter', onShowAdCounter as EventListener);
    player.addEventListener('vast.complete', onComplete);
    // A mid-roll that comes back without an ad ("no fill", failed request) ends on an error.
    player.addEventListener('vast.error', onComplete);
    player.addEventListener('seeking', onSeeking);

    return () => {
      player.removeEventListener('vast.showAdCounter', onShowAdCounter as EventListener);
      player.removeEventListener('vast.complete', onComplete);
      player.removeEventListener('vast.error', onComplete);
      player.removeEventListener('seeking', onSeeking);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!!counter && (
        <NextActionBarBtn>
          <Flex justify="center" align="center">
            <Timer>({counter})</Timer>
            {__t('player.showing_ad')}
          </Flex>
        </NextActionBarBtn>
      )}
    </>
  );
};

export default AdCounter;
